import { render, staticRenderFns } from "./MembershipListAddNew.vue?vue&type=template&id=5def54cd"
import script from "./MembershipListAddNew.vue?vue&type=script&lang=js"
export * from "./MembershipListAddNew.vue?vue&type=script&lang=js"
import style0 from "./MembershipListAddNew.vue?vue&type=style&index=0&id=5def54cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports